import Styled from "styled-components";

export interface MediaQueryProps {
  $lessThan?: "small" | "medium" | "large" | "xlarge";
  $between?: ["small" | "medium" | "large", "medium" | "large" | "xlarge"];
  $greaterThan?: "small" | "medium" | "large" | "xlarge";
}

const MediaQuery = Styled.div<MediaQueryProps>`
  display: none;

  ${(props) =>
    props.$lessThan &&
    `
    ${props.theme.breakpoints.down(props.$lessThan)} {
      display: block;
    }
  `}

  ${(props) =>
    props.$between &&
    `
    ${props.theme.breakpoints.between(props.$between[0], props.$between[1])} {
      display: block;
    }
  `}

  ${(props) =>
    props.$greaterThan &&
    `
    ${props.theme.breakpoints.up(props.$greaterThan)} {
      display: block;
    }
  `}
`;

export default MediaQuery;
